import {useEffect,useState} from 'react';
import {useIntl} from '@/react-intl';
import {Modal} from '@/design-system/ds-0/components/Modal';
import {useModuleStudio} from '../data/ModuleStudioDataProvider';
import type {ModuleSpecBlock} from '../data/moduleSpecContracts';
import ScreenCodeReference from './ScreenCodeReference';
import {componentPathOf,findCodeBlock} from './codeSourceLookup';
type Code=NonNullable<ModuleSpecBlock['code']>;
/**
 * GAP-76 (02.11.2026) : depuis un diagnostic de la porte de livraison sur `components/X.tsx`, le Maker corrige la source du composant
 * sans quitter le Studio. Le témoin est retrouvé dans la version livrée (bloc `code` → `artifactRef`), l'éditeur s'ouvre sur la ligne.
 */
export default function CodeSourceFixDialog({dossierId,version,file,line,onClose,onSaved}:{dossierId:string;version:number|null;file:string;line:number;onClose:()=>void;onSaved?:()=>void}){
 const {repository}=useModuleStudio(),intl=useIntl();
 const t=(id:string)=>intl.formatMessage({id});
 const path=componentPathOf(file);
 const [code,setCode]=useState<Code|null|undefined>(undefined);
 useEffect(()=>{let active=true;setCode(undefined);
  if(!path||version===null){setCode(null);return;}
  void repository.getModuleSpecVersion(dossierId,version).then(value=>{if(active)setCode(findCodeBlock(value.spec,path));}).catch(()=>{if(active)setCode(null);});
  return()=>{active=false;};},[repository,dossierId,version,path]);
 return <Modal open onClose={onClose} title={t('moduleStudio.generator.quality.fixTitle')} closeLabel={t('moduleStudio.command.close')} size="xl">
  <p className="text-sm"><code dir="ltr" className="break-all">{file}:{line}</code></p>
  {code===undefined?<p role="status">{t('moduleStudio.generator.quality.fixLoading')}</p>:code===null?<p role="alert">{t('moduleStudio.generator.quality.fixUnavailable')}</p>
   :<ScreenCodeReference dossierId={dossierId} code={code} editOnOpen focusLine={line} onSaved={onSaved}/>}
 </Modal>;
}
